<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="pb-md-0">
        <v-row class="mt-3 mt-md-1">
          <v-col>
            <v-file-input
              color="#979797"
              class="archivo"
              v-model="signableFile"
              accept="application/pdf"
              label="Archivo a firmar"
              prepend-icon
              show-size
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0">
            <v-text-field
              color="#979797"
              class="metadata"
              label="Información sobre archivo"
              v-model="metadata"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0">
            <v-btn
              block
              large
              class="float-right"
              @click="signDocument"
              color="secondary"
              :loading="loading"
            >
              <v-icon left>mdi-cloud-upload</v-icon>Firmar
            </v-btn>
          </v-col>
        </v-row>

        <v-alert v-show="firmaCorrecta" prominent type="success" class="mb-md-0">
          <v-row align="center">
            <v-col class="grow">El documento se encuentra firmado.</v-col>
            <v-col class="shrink">
              <v-btn target="_blank" v-bind:href="urlDocumento">Descargar</v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-alert v-show="firmaFallida" prominent type="error">
          <v-row align="center">
            <v-col class="grow">Hubo un error al firmar el documento.</v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FirmadorService from "../services/firmadorService";

export default {
  data() {
    return {
      signableFile: null,
      showSize: true,
      loading: false,
      firmaFallida: false,
      firmaCorrecta: false,
      idSignedDoc: "",
      metadata: ""
    };
  },
  computed: {
    urlDocumento: function() {
      return `http://152.74.16.184:8080/documentos/get/descarga/${this.idSignedDoc}`;
    }
  },
  methods: {
    fileSelected(file) {
      this.signableFile = file;
    },
    signDocument() {
      this.loading = true;
      this.$emit("documento-firmado", "");
      FirmadorService.firmar(this.signableFile, this.metadata)
        .then(response => {
          this.loading = false;
          this.firmaCorrecta = true;

          let data = response.data;
          this.idSignedDoc = data.result;
          this.$emit("documento-firmado", data.result);
        })
        .catch(error => {
          this.loading = false;
          this.firmaFallida = true;
          this.$emit("documento-firmado", "");
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss">
$weight: 200;
.archivo {
  font-weight: $weight;
}
.metadata {
  font-weight: $weight;
}
</style>
